import { render, staticRenderFns } from "./GenreTitles.vue?vue&type=template&id=7002365d&scoped=true&"
import script from "./GenreTitles.vue?vue&type=script&lang=js&"
export * from "./GenreTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002365d",
  null
  
)

export default component.exports